
export default class VehicleTracking {

    constructor(lat, lng, hg, sp, hardwareId) {
        this.lat = lat
        this.lng = lng
        this.hg = hg
        this.sp = sp
        this.hardwareId = hardwareId
    }

}
